<template>
  <div class="fwsed-summary-table">
    <content-loading v-if="isSummaryLoading" />
    <div v-else>
      <empty v-if="!summaryDocs.length">
        <h5 class="text-center">{{ $t("firm.audit.dashboard.no-data") }}</h5>
      </empty>
      <div v-else>
        <b-table small :items="summaryTableItems" :fields="summaryFields" responsive head-variant="light">
          <template #cell(firm)="{ item }">
            <span class="hand" @click="goToFirmDetail(item)"> {{ item.firm | translate }}</span>
          </template>
          <template #cell(status)="{ item }">
            <b-badge :variant="statusVariant(getFirmStatusForItem(item))">{{ formatStatus(getFirmStatusForItem(item)) }}</b-badge>
          </template>
        </b-table>
      </div>

      <div v-if="summaryPagination" class="row">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="summaryPagination.totalDocs" :per-page="summaryPagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFirmStatus } from "@/helpers/filters";
import ContentLoading from "@c/content-loading.vue";
import Empty from "@c/empty.vue";

export default {
  name: "FwsedSummaryTable",
  components: { ContentLoading, Empty },
  data() {
    return {
      request: {
        options: { page: 1, limit: 5, sort: { createdAt: "desc" } },
        query: {},
      },
      summaryFields: [
        { key: "firm", label: this.$t("firm.audit.dashboard.table.firm") },
        { key: "questionSetCount", label: this.$t("firm.audit.dashboard.table.question-sets") },
        { key: "answeredQuestionCount", label: this.$t("firm.audit.dashboard.table.answered") },
        { key: "approvedQuestionCount", label: this.$t("firm.audit.dashboard.table.approved") },
        { key: "status", label: this.$t("firm.audit.dashboard.table.status") },
      ],
    };
  },
  computed: {
    summaryPagination() {
      return this.$store.getters["firmAudit/summaryPagination"];
    },
    isSummaryLoading() {
      return this.$store.getters["firmAudit/isSummaryLoading"];
    },
    summaryDocs() {
      return this.summaryPagination?.docs ?? [];
    },
    summaryTableItems() {
      return this.summaryDocs.map((doc) => ({
        firm: doc.firm?.name,
        questionSetCount: doc.questionSetCount || 0,
        answeredQuestionCount: doc.answeredQuestionCount || 0,
        approvedQuestionCount: doc.approvedQuestionCount || 0,
        status: doc.firmStatus ?? doc.status,
        _doc: doc, // Keep reference for helper
      }));
    },
    currentProduct() {
      return this.$store.getters["product/currentProduct"] || "FWSED";
    },
  },

  watch: {
    request: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.init());
      },
    },
  },
  methods: {
    goToFirmDetail(item) {
      console.log(item);

      if (!item?._doc?.firm?._id) {
        return;
      }

      this.$router.push(`firm-management/${item._doc.firm._id}/audit`);
    },
    async init() {
      try {
        await this.$store.dispatch("firmAudit/fetchSummary", this.request);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    getFirmStatusForItem(item) {
      // item is from summaryTableItems, use firmStatus or get from original doc
      return item.status;
    },
    formatStatus(status) {
      if (!status) {
        return "-";
      }
      const questionSetMap = {
        FIRM_REVIEW: this.$t("firm.audit.status.firm-review"),
        BT_REVIEW: this.$t("firm.audit.status.bt-review"),
        COMPLETED: this.$t("firm.audit.status.completed"),
        IN_PROGRESS: this.$t("firm.audit.status.in-progress"),
        REJECTED: this.$t("firm.audit.status.rejected"),
        NONE: this.$t("firm.audit.status.none"),
      };
      const firmStatusMap = {
        REVIEW: this.$t("firm.status.review"),
        PRE_TEST: this.$t("firm.status.pre-test"),
        TEST: this.$t("firm.status.test"),
        PRE_PROD: this.$t("firm.status.pre-prod"),
        PROD: this.$t("firm.status.prod"),
        CANCELED: this.$t("firm.status.canceled"),
      };
      return firmStatusMap[status] || questionSetMap[status] || status;
    },
    statusVariant(status) {
      const questionSetVariantMap = {
        FIRM_REVIEW: "warning",
        BT_REVIEW: "info",
        COMPLETED: "success",
        IN_PROGRESS: "primary",
        REJECTED: "danger",
        NONE: "secondary",
      };
      const firmStatusVariantMap = {
        REVIEW: "secondary",
        PRE_TEST: "info",
        TEST: "warning",
        PRE_PROD: "primary",
        PROD: "success",
        CANCELED: "danger",
      };
      return firmStatusVariantMap[status] || questionSetVariantMap[status] || "secondary";
    },
  },
};
</script>
